export enum LinkType {
  Website,
  Page,
}
